module.exports = __webpack_public_path__ + "images/emoji/left_right_arrow.71df02448ca6bebf8c57.png";